export default __webpack_public_path__ + "static/sc-government-7f5254a10894f477357a97a9ec6eefed.webp";